export { default as MerchBanner } from './MerchBanner';
